import React from "react";
import { Alert, CircularProgress } from "@mui/material";

const PaymentSetupAlerts = ({
  error,
  successMessage,
  pollingMessage,
  onCloseError,
  onCloseSuccess,
}) => (
  <>
    {error && (
      <Alert severity="error" sx={{ mb: 2 }} onClose={onCloseError}>
        {error}
      </Alert>
    )}
    {successMessage && (
      <Alert severity="success" sx={{ mb: 2 }} onClose={onCloseSuccess}>
        {successMessage}
      </Alert>
    )}
    {pollingMessage && (
      <Alert
        severity="info"
        sx={{ mb: 2 }}
        icon={<CircularProgress size={20} />}
      >
        {pollingMessage}
      </Alert>
    )}
  </>
);

export default PaymentSetupAlerts;
